module.exports = __webpack_public_path__ + "img/icon96.6e2581e8.png";